import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import EngineIntervalListItemComponent from './EngineIntervalListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const EngineIntervalListComponent = ({ intervals, dictionaryScoringResponseColor, containerDispatcher, isReadOnly, validation }) => {
  const { t } = useTranslation();
  return (
    <CardNoResultsWrapper content={intervals?.engineIntervals}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('EngineScoring.EngineInterval.StartsWith')}</TableCell>
            <TableCell>{t('EngineScoring.EngineInterval.EndsWith')}</TableCell>
            <TableCell>{t('EngineScoring.EngineInterval.Result')}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {intervals.engineIntervals.map((item, idx) => {
            return (
              <EngineIntervalListItemComponent
                item={item}
                key={idx}
                index={idx}
                containerDispatcher={containerDispatcher}
                dictionaryScoringResponseColor={dictionaryScoringResponseColor}
                isReadOnly={isReadOnly}
                validation={validation[idx]}
              />
            );
          })}
        </TableBody>
      </Table>
    </CardNoResultsWrapper>
  );
};

EngineIntervalListComponent.propTypes = {
  dictionaryScoringResponseColor: PropTypes.array.isRequired,
  intervals: PropTypes.object.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired
};

export default EngineIntervalListComponent;
